import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTheme } from '@emotion/react';

const SimSectionHeader = ({ title }) => {
	const theme = useTheme();

	return (
		<Grid item sm={10} sx={{ my: { md: 2, xs: 1.5 } }}>
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<Typography
						variant='h5'
						color='white'
						sx={{
							fontSize: '3.5rem',
							fontWeight: 500,
							lineHeight: 1.4,
							[theme.breakpoints.down('md')]: { fontSize: '1.2rem' }
						}}>
						SIM SOULS GROUP LLC and SIM SOULS Institute 1 INC
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<Typography
						variant='h5'
						color='white'
						sx={{
							fontSize: '2rem',
							fontWeight: 400,
							lineHeight: 1.4,
                            textTransform: 'uppercase',
							[theme.breakpoints.down('md')]: { fontSize: '1.1rem' }
						}}>
						{title}
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<Typography
						color='white'
						sx={{
							fontWeight: 300,
							lineHeight: 1.3,
							[theme.breakpoints.down('md')]: { fontSize: '0.75rem' },
							[theme.breakpoints.up('md')]: { my: 0, mx: 12.5 }
						}}>
						Last updated on 20th Jun 2023
					</Typography>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default SimSectionHeader;
